import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private toggleHeader = new BehaviorSubject<string>('');
  toggleHeaders = this.toggleHeader.asObservable();

  constructor() { }

  removeHeader(columnName: string): void {
    this.toggleHeader.next(columnName);
  }

}
